import * as ng from 'angular';
import { Moment } from 'moment';
import { Templates } from "./assets";
import { ComponentRegistration } from './core';
import { IAuthService } from './components/security';
import { IThemesService } from './services';

let appTemplate = require("./app.html");

class AppComponent extends ComponentRegistration {

    constructor() {
        super('app', {
            templateUrl: appTemplate,
            controller: AppController,
            controllerAs: "app",
            $routeConfig: [
                { path: '/', component: 'home', name: 'Home', useAsDefault: true },
                { path: '/faq', component: 'faq', name: 'Faq' },
                { path: '/terms', component: 'terms', name: 'Terms' },
                { path: '/sign-in', component: 'signIn', name: 'SignIn' },
                { path: '/account-request', component: 'accountRequest', name: 'AccountRequest' },
                { path: '/account-request-completed', component: 'accountRequestCompleted', name: 'AccountRequestCompleted' },
                { path: '/forgot-password', component: 'forgotPassword', name: 'ForgotPassword' },
                { path: '/reset-password', component: 'resetPassword', name: 'ResetPassword' },
                { path: '/change-password', component: 'changePassword', name: 'ChangePassword' },
                { path: '/dashboard', component: 'overview', name: 'Dashboard' },
                { path: '/dashboard/overview', component: 'overview', name: 'Overview' },
                { path: '/dashboard/account-activity', component: 'accountActivity', name: 'AccountActivity' },
                { path: '/dashboard/account', component: 'accountInfo', name: 'AccountInfo' },
                { path: '/dashboard/media', component: 'media', name: 'Media' },
                { path: '/dashboard/message', component: 'message', name: 'Message' },
                { path: '/security', component: 'security', name: 'Security' },
                { path: '/application', component: 'application', name: 'Application' },
                { path: '/admin/...', component: 'admin', name: 'Admin' },
                { path: '/profile', component: 'profile', name: 'Profile' },
            ]
        });
    }
}

interface IAppController {

    onLogoutClick(args): void;
    onLanguageChange(args): void;
}

class AppController implements IAppController {
    private today: Date;
    private selectedLanguageCode: string;
    //public footerUrl: string = Templates.footer;
    public themeLoaded: boolean = false;
    public static $inject: Array<string> = ['$rootRouter', 'gettextCatalog', 'Auth', 'Themes', 'moment'];
    constructor(private $router: any,
        private gettextCatalog: ng.gettext.gettextCatalog,
        private Auth: IAuthService,
        private Themes: IThemesService,
        moment: Moment
    ) {

        this.today = new Date();
        this.selectedLanguageCode = 'en';
        (window as any).moment = moment;
        console.log("main app contorller constructed.");
    }

    public $onInit(): void {
        this.Themes.loadThemes()
            .then((loaded) => {
                this.themeLoaded = loaded;
            });
    }

    public onLogoutClick(): void {
        this.Auth.clearTokens();
        // causes auto redirect to login
        //$rootScope.profile = {};
        this.$router.navigate(['Home']);
    }

    public onLanguageChange() {
        this.gettextCatalog.setCurrentLanguage(this.selectedLanguageCode);
    }
}

let appComponent = new AppComponent();
export default appComponent;
export { appComponent }



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/app-component.ts